const defaultThClass = '!bg-[#F4F4F4] !font-medium !text-[14px] text-left !text-[#333333] text-capitalize'
const defaultTdClass = 'text-[#333333] text-left align-middle !text-[14px'

export const statusMapping = {
  Proses: {
    label: 'Proses',
    color: '#FBA63C',
    bgColor: '#FFF2E2',
  },
  Selesai: {
    label: 'Selesai',
    color: '#34A770',
    bgColor: '#DCF3EB',
  },
  Dibatalkan: {
    label: 'Dibatalkan',
    color: '#E31A1A',
    bgColor: '#FFEDED',
  },
  unknown: {
    label: 'Unknown',
    color: '#000000',
    bgColor: '#E2E2E2',
  },
}

export const fieldListInbound = [
  {
    key: 'inbound_date',
    label: 'Tanggal Pengajuan',
    thClass: `${defaultThClass} min-w-[205px]`,
    tdClass: defaultTdClass,
  },
  {
    key: 'partner_name',
    label: 'Nama Partner',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'shipping',
    label: 'Jenis Pengiriman',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'no_resi',
    label: 'No. Resi',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'status',
    label: 'Status',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'action',
    label: 'Action',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
]

export const fieldProduct = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'variant',
    label: 'Variasi',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    formatter: value => (value || '-'),
  },
  {
    key: 'total_inbound',
    label: 'Dikirim',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'total_inbound_confirm',
    label: 'Diterima Gudang',
    thClass: `${defaultThClass} !w-[210px]`,
    tdClass: defaultTdClass,
  },
]

export const modalMessages = {
  confirm: {
    title: 'Konfirmasi Data Inbound',
    description: 'Apakah data yang kamu konfirmasi sudah sesuai dengan keadaan barang inbound?',
    type: 'confirm',
    confirmText: 'Yakin',
  },
  success: {
    title: 'Berhasil Dikonfirmasi',
    description: 'Konfirmasi berhasil diterima untuk data yang masuk, menunjukkan bahwa semua informasi telah diproses dengan baik dan siap untuk langkah selanjutnya.',
    type: 'success',
  },
}

export const fieldProductConfirm = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'variant_name',
    label: 'Variasi',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    formatter: value => (value || '-'),
  },
  {
    key: 'total_inbound',
    label: 'Dikirim',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
  {
    key: 'total_inbound_confirm',
    label: 'Diterima Gudang',
    thClass: `${defaultThClass} !w-[210px]`,
    tdClass: defaultTdClass,
  },
  {
    key: 'dimension',
    label: 'Dimensi',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
  },
]

export const fieldSelisih = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'bg-[#F4F4F4] text-left text-capitalize !text-black',
    tdClass: 'text-black text-left align-top',
  },
  {
    key: 'variant',
    label: 'Variasi',
    thClass: 'bg-[#F4F4F4] text-left text-capitalize !text-black',
    tdClass: 'text-black text-left align-top',
  },
  {
    key: 'total_inbound',
    label: 'Dikirim',
    thClass: 'bg-[#F4F4F4] text-capitalize !text-black',
    tdClass: 'text-black space-y-3 align-top',
  },
  {
    key: 'total_inbound_confirm',
    label: 'Diterima Gudang',
    thClass: 'bg-[#F4F4F4] text-capitalize !text-black',
    tdClass: 'text-black space-y-3 align-top',
  },
  {
    key: 'selisih',
    label: 'Selisih',
    thClass: 'bg-[#F4F4F4] text-capitalize !text-black',
    tdClass: 'text-black space-y-3 align-top',
  },
]
export const fieldBarangRusak = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'bg-[#F4F4F4] text-left text-capitalize !text-black',
    tdClass: 'text-black text-left align-top',
  },
  {
    key: 'variant',
    label: 'Variasi',
    thClass: 'bg-[#F4F4F4] text-left text-capitalize !text-black',
    tdClass: 'text-black text-left space-y-3 align-top',
  },
  {
    key: 'total_inbound',
    label: 'Dikirim',
    thClass: 'bg-[#F4F4F4] text-capitalize !text-black',
    tdClass: 'text-black space-y-3 align-top',
  },
  {
    key: 'total_inbound_confirm',
    label: 'Diterima Gudang',
    thClass: 'bg-[#F4F4F4] text-capitalize !text-black',
    tdClass: 'text-black space-y-3 align-top',
  },
]

export const kondisiOptions = [
  { value: 0, name: 'Tidak ada barang yang rusak' },
  { value: 1, name: 'Ada barang yang rusak' },
]
